import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import _isNaN from 'lodash/isNaN';
import Numeral from 'numeral';
import _ClassNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import Rating from 'components/Rating';

const styles = theme => ({
  icon: {
    width: 12,
    [theme.breakpoints.down('1200')]: {
      width: 10,
    },
    [theme.breakpoints.down('960')]: {
      width: 12,
    },
  },
  iconWrapper: {
    display: 'flex !important',
    flexDirection: 'row',
    height: 14,
    alignItems: 'center',
  },
  text: {
    marginLeft: 5,
    ...theme.typography.pxSmall,
  },
  rating: {
    display: 'flex',
  },
  notApplicableText: {
    fontSize: 10,
    color: '#979797',
  },
  textCount: theme.typography.pxSmall,
  anchorText: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
});

function ResourceRating(props) {
  const {
    classes,
    rating,
    type,
    userRatingCount,
    isBig,
    hasUserLink,
    slug,
  } = props;
  const experRatingSpecificValueToHide =
    (type !== 'user' && rating === 3.625) ||
    (type === 'user' && rating === 3.75);
  return (
    <Grid item xs={12} className={classes.rating}>
      {_isNaN(rating) || rating === 0 || experRatingSpecificValueToHide ? (
        <Typography className={classes.notApplicableText}>
          Not Available
        </Typography>
      ) : (
        <>
          <Rating
            name={`${type || 'expert'}-${slug}-rating`}
            value={rating}
            isBig={isBig}
          />
          <Typography className={classes.text} color="textPrimary">
            {rating && rating !== 0 && !_isNaN(rating)
              ? Number.parseFloat(rating).toFixed(1)
              : ''}
          </Typography>
          {type === 'user' && !_isNaN(userRatingCount) && !!userRatingCount && (
            <Typography
              className={_ClassNames(
                classes.textCount,
                isBig && hasUserLink ? classes.anchorText : undefined,
              )}
              color="textPrimary"
            >
              {`(${Numeral(userRatingCount).format('0a')})`}
            </Typography>
          )}
        </>
      )}
    </Grid>
  );
}
ResourceRating.propTypes = {
  classes: PropTypes.object,
  rating: PropTypes.number,
  type: PropTypes.string,
  userRatingCount: PropTypes.any,
  isBig: PropTypes.bool,
  hasUserLink: PropTypes.bool,
  slug: PropTypes.string,
};

export default withStyles(styles)(ResourceRating);
